module.exports = __webpack_public_path__ + "img/reset.39aebe09.svg";